import { createSlice } from '@reduxjs/toolkit'

const STORAGE_KEY = 'buyer_view_switch'

const getStoredValue = (): boolean => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || 'false') === true
  } catch {
    return false
  }
}

// When true, the dashboard shows the Buyer cards regardless of the user's type
const buyerViewSwitch = createSlice({
  name: "buyerViewSwitch",
  initialState: {
    isBuyerView: getStoredValue(),
  },
  reducers: {
    setBuyerViewSwitch(state, action) {
      state.isBuyerView = action.payload
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(action.payload))
      } catch {}
    },
  }
})
export default buyerViewSwitch.reducer;
export const { setBuyerViewSwitch } = buyerViewSwitch.actions;
